import { useQuery } from '@tanstack/react-query';
import { useNotificationStream } from '../lib/notifications-stream.js';
import { meQuery } from '../lib/queries.js';

// Mounted once at app root (main.tsx) inside the QueryClientProvider.
// Opens an SSE connection once the user is authenticated; renders
// nothing. Toast firing + cache invalidation happen inside the hook.
//
// We can't just open the stream unconditionally — pre-login the
// endpoint 401s and the EventSource would burn through its reconnect
// budget. Gating on meQuery means: stay quiet until we know there's
// a session.

export function NotificationStreamMount(): null {
  const { data: me } = useQuery(meQuery());
  useNotificationStream({ enabled: Boolean(me) });
  return null;
}
